import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import GlobalStateContext from './globalState';
import { translationsDictionary } from '../../gatsby-generated/translationsDictionary'; // Import the generated dictionary

const Translate = ({ id, foldername = 'default', filename = 'default', values = {}, defaultValue = '' }) => {
  const { language } = useContext(GlobalStateContext);

  const translation =
    translationsDictionary[language]?.[foldername]?.[filename]?.[id] ||
    translationsDictionary['en']?.[foldername]?.[filename]?.[id] ||
    defaultValue || id;

  let finalTranslation = translation;
  Object.keys(values).forEach((placeholder) => {
    const regex = new RegExp(`{{${placeholder}}}`, 'g');
    finalTranslation = finalTranslation.replace(regex, values[placeholder]);
  });

  return <>{finalTranslation}</>;
};

Translate.propTypes = {
  id: PropTypes.string.isRequired,
  foldername: PropTypes.string,
  filename: PropTypes.string,
  values: PropTypes.object,
};

export default Translate;
